import { sessionManager } from '../auth/session.js';
import { type ApiClient, createClient } from './orpc.js';

/**
 * The authenticated client. Everything except sign-in and refresh uses it.
 *
 * The access token is attached per request rather than captured once, and
 * asking for it is what triggers a silent refresh when it has gone stale. A
 * request therefore never carries a token that expired while the parent was
 * reading the page.
 */
export const apiClient: ApiClient = createClient(() => sessionManager.accessToken());
